@if (tree) {
  <div
    class="tree">
    @for (item of tree; track item) {
      <app-tree-item
        [item]="item"
        [selectedItems]="selectedNodes"
        [showCount]="showCount"
        (selectItem)="selectNode.emit($event)"
        (deselectItem)="deselectNode.emit($event)"/>
    }
  </div>
}
